/**
 * Read-only block-explorer link builders. Matches the URLs the on-chain stack
 * uses (see elios-poc `demo-testnet.ts` / `try-withdraw.ts`):
 *   - HyperEVM mainnet (999): https://hyperevmscan.io
 *   - HyperEVM testnet (998): https://explore-testnet.hyperpc.app
 * CCTP settlement mints land on Base, so destination mint tx links point at Basescan.
 */

function hyperevmBase(chainId: number | null | undefined): string {
  return chainId === 998 ? "https://explore-testnet.hyperpc.app" : "https://hyperevmscan.io";
}

export function addressUrl(address: string | null | undefined, chainId?: number | null): string | null {
  if (!address || !address.startsWith("0x")) return null;
  return `${hyperevmBase(chainId)}/address/${address}`;
}

export function txUrl(hash: string | null | undefined, chainId?: number | null): string | null {
  if (!hash || !hash.startsWith("0x")) return null;
  return `${hyperevmBase(chainId)}/tx/${hash}`;
}

/** Base L2 explorer (CCTP mint destination). */
export function baseTxUrl(hash: string | null | undefined): string | null {
  if (!hash || !hash.startsWith("0x")) return null;
  return `https://basescan.org/tx/${hash}`;
}

export function baseAddressUrl(address: string | null | undefined): string | null {
  if (!address || !address.startsWith("0x")) return null;
  return `https://basescan.org/address/${address}`;
}
